export default "__VITE_ASSET__EXzJxlbIWeRcMTxRJa4XOg__"